module.exports = __webpack_public_path__ + "img/refresh_blue.341756f2.svg";